module.exports = __webpack_public_path__ + "img/gear.89d1a068.svg";